import type { IconData } from '@stacksjs/iconify-core'

export const mouseWirelessSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M41.423 18.303c.049 1.71.077 3.604.077 5.697s-.028 3.987-.077 5.697c-.141 4.937-1.97 9.16-5.082 12.149C33.23 44.833 28.928 46.5 24 46.5s-9.23-1.667-12.34-4.654c-3.113-2.99-4.942-7.212-5.083-12.149C6.528 27.987 6.5 26.093 6.5 24s.028-3.987.077-5.697c.141-4.937 1.97-9.16 5.082-12.149C14.77 3.167 19.072 1.5 24 1.5s9.23 1.667 12.34 4.654c3.113 2.99 4.942 7.212 5.083 12.149M26.5 11a2.5 2.5 0 0 0-5 0v6a2.5 2.5 0 0 0 5 0z\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default mouseWirelessSolid
